<p-toast position="top-right"></p-toast>

<div class="ssr" [class.ssr--loading]="loading">
  <div *ngIf="loading" class="ssr-loader" aria-hidden="true">
    <p-progressSpinner [style]="{width: '36px', height: '36px'}"
      styleClass="custom-spinner" strokeWidth="8" fill="#EEEEEE"
      animationDuration=".5s"></p-progressSpinner>
  </div>

  <div class="ssr-header">
    <h2 class="ssr-title">Admission Fee Reports</h2>
  </div>

  <div class="ssr-filters">
    <div class="ssr-filter-group">
      <span class="ssr-filter-label">From</span>
      <p-calendar styleClass="ssr-cal" [yearNavigator]="true" yearRange="1950:2040"
        [monthNavigator]="true" [(ngModel)]="from" placeholder="From Date"
        name="joinDate" [inline]="false" dateFormat="dd/mm/yy" [showIcon]="true"
        appendTo="body">
      </p-calendar>
    </div>
    <div class="ssr-filter-group">
      <span class="ssr-filter-label">To</span>
      <p-calendar styleClass="ssr-cal" [yearNavigator]="true" yearRange="1950:2040"
        [monthNavigator]="true" [(ngModel)]="to" placeholder="To Date"
        name="joinDate" [inline]="false" dateFormat="dd/mm/yy" [showIcon]="true"
        appendTo="body">
      </p-calendar>
    </div>
    <div class="ssr-filter-group">
      <span class="ssr-filter-label">Search By</span>
      <p-dropdown [options]="options" [(ngModel)]="selectedOption"
        (onChange)="dropdownChange()" styleClass="ssr-dd" panelStyleClass="ssr-dd-panel"
        appendTo="body"></p-dropdown>
    </div>
    <div class="ssr-filter-group" *ngIf="selectedOption == 'Member'">
      <span class="ssr-filter-label">Search Member</span>
      <input class="ssr-search" [(ngModel)]="tagNumber" autocomplete="off"
        placeholder="Search by Membership ID" type="number" name="tagNumber">
    </div>
    <div class="ssr-filter-group" *ngIf="selectedOption == 'Visitor'">
      <span class="ssr-filter-label">Search Visitor</span>
      <input class="ssr-search" [(ngModel)]="visitorContact" autocomplete="off"
        placeholder="Search by Contact" type="text" name="contact">
    </div>
    <div class="ssr-filter-group" *ngIf="selectedOption == 'Trainer'">
      <span class="ssr-filter-label">Search Trainer</span>
      <input class="ssr-search" [(ngModel)]="trainer" autocomplete="off"
        placeholder="Search by Name" type="text" name="trainerName">
    </div>
    <div class="ssr-actions">
      <button type="button" class="ssr-btn ssr-btn--primary" (click)="search()" [disabled]="loading">
        <i class="pi pi-search" aria-hidden="true"></i>
        <span>Search</span>
      </button>
      <button type="button" class="ssr-btn" (click)="resetFilter()" [disabled]="loading">
        <i class="pi pi-times" aria-hidden="true"></i>
        <span>Clear</span>
      </button>
      <button type="button" class="ssr-btn ssr-btn--print" (click)="printAllInvoice()"
        [disabled]="loading || !memberAdmissionsReport?.length">
        <i class="pi pi-print" aria-hidden="true"></i>
        <span>Print</span>
      </button>
    </div>
  </div>

  <div class="ssr-table-card">
    <p-table [value]="memberAdmissionsReport" [paginator]="true" [rows]="10" [responsive]="true"
      [loading]="loading" styleClass="ssr-table" class="p-table-tecfolk-fix">
      <ng-template pTemplate="header">
        <tr>
          <th>Membership No</th>
          <th>Name</th>
          <th>Registration Fee</th>
          <th>Montly Fee</th>
          <th>Joining Date</th>
          <th>Total Fee</th>
          <th>Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData>
        <tr>
          <td [attr.data-label]="'Membership No'">{{ rowData.tagNumber }}</td>
          <td [attr.data-label]="'Name'">{{ rowData.name }}</td>
          <td [attr.data-label]="'Registration Fee'">
            <span class="ssr-money">{{ rowData.registerationFee }}</span>
          </td>
          <td [attr.data-label]="'Montly Fee'">
            <span class="ssr-money">{{ rowData.monthFee }}</span>
          </td>
          <td [attr.data-label]="'Joining Date'">{{ rowData.joiningDate | date: 'dd/MM/yyyy' }}</td>
          <td [attr.data-label]="'Total Fee'">
            <span class="ssr-money ssr-money--total">{{ rowData.totalRegMonth }}</span>
          </td>
          <td [attr.data-label]="'Action'">
            <button type="button" class="ssr-btn" (click)="viewDetail(rowData)">
              <i class="fa fa-eraser" aria-hidden="true"></i>
              <span>View Detail</span>
            </button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7" class="ssr-empty">No records found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div class="ssr-summary" *ngIf="memberAdmissionsReport?.length">
    <div class="ssr-summary-title">Summary</div>
    <div class="ssr-summary-cards">
      <div class="ssr-stat">
        <span class="ssr-stat-label">Total Month Fee</span>
        <span class="ssr-stat-value">{{ totalmontlyFee | number:'1.0-0' }}</span>
      </div>
      <div class="ssr-stat">
        <span class="ssr-stat-label">Total Registration Fee</span>
        <span class="ssr-stat-value">{{ totalRegistrationFee | number:'1.0-0' }}</span>
      </div>
      <div class="ssr-stat ssr-stat--paid">
        <span class="ssr-stat-label">Total</span>
        <span class="ssr-stat-value">{{ total | number:'1.0-0' }}</span>
      </div>
    </div>
  </div>
</div>

<div id="allmemberAdmissionsReport" style="display: none;">
  <div class="invoice-box">
    <table cellpadding="0" cellspacing="0">
      <tr class="top">
        <td colspan="4">
          <table>
            <tr>
              <td class="title">
                <img [src]=" (company.bannerImage ? config.Server + 'assets/layout/images/companies/' + company.bannerImage : 'assets/layout/images/logoCompany.png')"
                  alt="Company Logo" style="width:100%; max-width:300px;">
              </td>
              <td>
                Created: {{date | date: 'dd/MM/yyyy'}}
              </td>
            </tr>
          </table>
        </td>
      </tr>
      <tr>
        <td>Cell: {{branch.phone}}<br />{{branch.address}}</td>
      </tr>
      <tr class="information">
        <td colspan="4">
          <table>
            <tr>
              <td></td>
              <td></td>
            </tr>
          </table>
        </td>
      </tr>
      <tr>
        <table>
          <tbody>
            <tr class="heading">
              <th>Membership No</th>
              <th>Name</th>
              <th>Joining Date</th>
              <th>Registration Fee</th>
              <th>Montly Fee</th>
              <th>Total Fee</th>
            </tr>
            <tr class="item" *ngFor="let item of memberAdmissionsReport">
              <td>{{item.tagNumber}}</td>
              <td>{{item.name}}</td>
              <td>{{item.joiningDate | date: 'dd/MM/yyyy'}}</td>
              <td>{{item.registerationFee}}</td>
              <td>{{item.monthFee}}</td>
              <td>{{item.totalRegMonth}}</td>
            </tr>
          </tbody>
        </table>
      </tr>
    </table>
    <div style="width: 110px;float: right;">
    </div>
    <div class="logoDiv">
      Powered by &nbsp; <a href="http://tecfolk.com/" target="_blank"><img style="width:66px;"
          src="http://tecfolk.com/Content/img/tecfolk-logo-trasprantNormal.png" alt=""></a>
    </div>
  </div>
</div>
